import React, { useState } from 'react';
import './ResumeLink.css';

const ResumeLink = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleResumeDownload = () => {
    setIsDownloading(true);
    const resumeUrl = '/Hamid.pdf';
    fetch(resumeUrl)
      .then(response => response.blob())
      .then(blob => {
        const pdfUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.setAttribute('download', 'Hamid.pdf');
        link.click();
        setIsDownloading(false);
      })
      .catch(error => {
        console.error('Error downloading resume:', error);
        setIsDownloading(false);
      });
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
    const resumeUrl = '/Hamid.pdf';
    window.open(resumeUrl, '_blank');
  };

  return (
    <div id="resume" className="resume-container">
      <div>
        <h2>Click to Download</h2>
        <a 
          href="#!" 
          onMouseEnter={handleMouseEnter} 
          onClick={handleResumeDownload} 
          className="resume-link"
        >
          {isDownloading ? 'Downloading...' : <h2>Resume</h2>}
        </a>
      </div>
    </div>
  );
};

export default ResumeLink;
